const organization = {
    require_membership: '用戶必須是組織的成員才能繼續。',
    role_names_not_found: '檢測到無效的角色名稱：{{names,list(type:conjunction)}}。請先創建這些角色再繼續。',
};
export default Object.freeze(organization);
